//login endpoint
export const LOGIN_ENDPOINT = '/users/login';

//profile endpoint
export const PROFILE_ENDPOINT = '/users/me';

//users endpoint
export const USERS_ENDPOINT = '/admin/users';

// users with subscriptions endpoint
export const USERS_SUBSCRIPTIONS_ENDPOINT = '/admin/users/subscriptions';

// user statistics endpoint
export const USER_STATS_ENDPOINT = '/admin/users/stats';

// total subscriptoion endpoint
export const TOTAL_SUBSCRIPTIONS_ENDPOINT = '/admin/subscriptions/stats';

// support tickets endpoints
export const SUPPORT_TICKETS_ENDPOINT = '/contact-support/admin/all';
export const SUPPORT_STATISTICS_ENDPOINT = '/contact-support/admin/statistics';
export const SUPPORT_RESPOND_ENDPOINT = '/contact-support/admin';
export const SUPPORT_CATEGORY_ENDPOINT = '/contact-support/admin/category';

// subscription packages endpoint
export const SUBSCRIPTION_PACKAGES_ENDPOINT = '/subscription-packages';
export const SUBSCRIPTION_PACKAGES_STATS_ENDPOINT = '/subscription-packages/admin/statistics';
export const SEARCH_SUBSCRIPTION_BY_EMAIL = '/admin/users/{email}/subscriptions';
export const MANUAL_ACTIVATE_SUBSCRIPTION_BY_EMAIL = '/admin/users/{email}/subscriptions/activate'
export const ELEVATE_USER_BY_ID = "/admin/users/{id}/elevate-to-admin"
export const DEMOTE_USER_BY_ID = "/admin/users/{id}/demote-to-user"

// Email Notification System Endpoints
export const MESSAGE_TEMPLATES_ENDPOINT = '/message-templates';
export const MESSAGE_TEMPLATE_BY_ID_ENDPOINT = '/message-templates/{id}';
export const MESSAGE_TEMPLATE_TOGGLE_ENDPOINT = '/message-templates/{id}/toggle';

export const SCHEDULED_MESSAGES_ENDPOINT = '/scheduled-messages';
export const SCHEDULED_MESSAGE_SCHEDULE_ENDPOINT = '/scheduled-messages/schedule';
export const SCHEDULED_MESSAGE_SEND_NOW_ENDPOINT = '/scheduled-messages/send-now';
export const SCHEDULED_MESSAGE_BY_ID_ENDPOINT = '/scheduled-messages/{id}';
export const SCHEDULED_MESSAGE_CANCEL_ENDPOINT = '/scheduled-messages/{id}/cancel';

export const CRON_JOBS_ENDPOINT = '/cron-jobs';
export const CRON_JOB_BY_ID_ENDPOINT = '/cron-jobs/{id}';
export const CRON_JOB_TOGGLE_ENDPOINT = '/cron-jobs/{id}/toggle';
export const CRON_JOBS_RELOAD_ENDPOINT = '/cron-jobs/reload';
export const CRON_EXPRESSION_HELP_ENDPOINT = '/cron-jobs/help/cron-expression';

export const EMAIL_LOGS_ENDPOINT = '/email-logs';
export const EMAIL_LOGS_STATISTICS_ENDPOINT = '/email-logs/statistics';
export const EMAIL_LOGS_CLEANUP_ENDPOINT = '/email-logs/cleanup';

// Free Subscription Management Endpoints
export const FREE_SUBSCRIPTION_WELCOME_BONUS_ENDPOINT = '/free-subscriptions/welcome-bonus';
export const FREE_SUBSCRIPTION_PROMOTIONS_ENDPOINT = '/free-subscriptions/promotions';
export const FREE_SUBSCRIPTION_PROMOTION_BY_ID_ENDPOINT = '/free-subscriptions/promotions/{id}';
export const FREE_SUBSCRIPTION_PROMOTION_APPLY_ENDPOINT = '/free-subscriptions/promotions/{id}/apply';
export const FREE_SUBSCRIPTION_GRANT_ENDPOINT = '/free-subscriptions/grant';
export const FREE_SUBSCRIPTION_LOGS_ENDPOINT = '/free-subscriptions/logs';
export const FREE_SUBSCRIPTION_STATISTICS_ENDPOINT = '/free-subscriptions/statistics';
export const FREE_SUBSCRIPTION_USER_HISTORY_ENDPOINT = '/free-subscriptions/users/{userId}/history';
export const FREE_SUBSCRIPTION_USER_DEVICES_ENDPOINT = '/free-subscriptions/users/{userId}/devices';
export const FREE_SUBSCRIPTION_DEVICE_USERS_ENDPOINT = '/free-subscriptions/devices/{deviceId}/users';
export const FREE_SUBSCRIPTION_USER_ELIGIBILITY_ENDPOINT = '/free-subscriptions/users/{userId}/eligibility';
export const FREE_SUBSCRIPTION_ABUSE_DETECT_ENDPOINT = '/free-subscriptions/abuse/detect';

// App Version Management Endpoints
export const APP_VERSIONS_UPLOAD_ENDPOINT = '/app-versions/upload';
export const APP_VERSIONS_ENDPOINT = '/app-versions';
export const APP_VERSION_BY_ID_ENDPOINT = '/app-versions/{id}';
export const APP_VERSION_APPROVE_ENDPOINT = '/app-versions/{id}/approve';
export const APP_VERSION_REJECT_ENDPOINT = '/app-versions/{id}/reject';
export const APP_VERSION_ACTIVATE_ENDPOINT = '/app-versions/{id}/activate';
export const APP_VERSION_DOWNLOAD_ENDPOINT = '/app-versions/download/{id}';
export const APP_VERSION_DELETE_ENDPOINT = '/app-versions/{id}';
export const APP_VERSION_STATISTICS_ENDPOINT = '/app-versions/statistics/summary';
export const APP_VERSION_ACTIVE_ENDPOINT = '/app-versions/active/current';
export const APP_VERSION_INFO_ENDPOINT = '/api/app/version';
